import { PersistedState } from 'redux-persist';
import { initialState as is0 } from './0';

export const migrations = {
	34: (state) => is0 as unknown as PersistedState,
	35: (state) => is0 as unknown as PersistedState,
};
